import { addTranslation } from '../../../_helpers/Translate';

addTranslation({
  ru: {
    serviceProviders_title: 'Реестр услугодателей',
    serviceProviders_errorLoad: 'Не удалось загрузить данные реестра услугодателей',
    serviceProviders_columnId: 'Номер',
    serviceProviders_columnIin: 'ИИН',
    serviceProviders_columnBin: 'БИН',
    serviceProviders_columnTypeName: 'Тип',
    serviceProviders_columnLocation: 'Населенный пункт',
    serviceProviders_columnName: 'Наименование',
    serviceProviders_columnAction: 'Действие',
    serviceProviders_clearFilter:"Очистить фильтр",
    serviceProviders_verifyAddress:'Проверить прописку',
    serviceProviders_changeFilterForChoiceDDO:'В выбранном регионе нет доступных дошкольных организаций, которые соответствуют указанному типу коррекции или виду реабилитации.',


    serviceProviders_create: 'Создать услугодателя',
    serviceProviders_close: 'Закрыть организацию',
    serviceProviders_reopened: 'Переоткрыть организацию',

    serviceProviders_errorLoadTable: 'Не удалось загрузить реестр услугодателей',
    serviceProviders_errorVerifyAddress:'Не удалось проверить адресную прописку',
    serviceRequest_addressValid:'Проверка адресной прописки прошла успешно',
    serviceRequest_addressNotFound:'В настоящее время информация о Вашей временной/постоянной прописке недоступна для автоматической обработки по интеграции с ИС ГБДФЛ',
    serviceRequest_addressNotMatch:'Отсутствует постоянная или временная регистрация в населенном пункте оказания государственной услуги. Подача заявления невозможна. Обратитесь в органы регистрации для получения временной или постоянной регистрации.',
    serviceProviders_errorChangeFilter: 'Не удалось поменять фильтр',
    serviceProviders_deleteSuccess: 'Удаление услугодателей прошло успешно',
    serviceProviders_deleteError: 'Не удалось удалить услугодателей',

    serviceProviders_heirCloseTitle: 'Наследование заявок закрываемого услугодателя',
    serviceProviders_heir_choose_providers: 'Выберите услугодателя',
    serviceProviders_heirCloseSuccess:
      'Наследования истории от услугодателя успешно закрыта',
    serviceProviders_heirCloseError:
      'Не удалось закрыть наследования истории от услугодателя',
    serviceProviders_heirReopened_title: `Переоткрыть наследования`,
    serviceProviders_heirReopened: `Вы хотите переоткрыть организацию с номером бин {{id}} ?`,
    serviceProviders_heirReopenedSuccess:
      'Наследования истории от услугодателя успешно переоткрыта',
    serviceProviders_heirReopenedError:
      'Не удалось открыть наследования истории от услугодателя',
    serviceProviders_fioChild: 'ФИО ребенка',
    serviceProviders_exitedErrorListChildren: 'Не удалось загрузить список детей',
    serviceProviders_didGiveYourConsent: 'Вы не дали согласие на сбор и обработку данных.',
  },
  kk: {
    serviceProviders_title: 'Қызмет көрсетушілердің тізілімі',
    serviceProviders_errorLoad:
      'Қызмет көрсетушілер тізілімінің деректерін жүктеу мүмкін емес',
    serviceProviders_columnId: 'Нөмірі',
    serviceProviders_columnIin: 'ЖСН',
    serviceProviders_columnTypeName: 'Түрі',
    serviceProviders_columnLocation: 'Аймақ',
    serviceProviders_columnBin: 'БСН',
    serviceProviders_columnName: 'Атауы',
    serviceProviders_columnAction: 'Әрекет',
    serviceProviders_clearFilter:"Сүзгіні жою",
    serviceProviders_verifyAddress:'Мекенжай тіркемесін тексеру',
    serviceProviders_changeFilterForChoiceDDO:'Таңдалған өңірде көрсетілген түзету түріне немесе оңалту түріне сәйкес келетін қолжетімді мектепке дейінгі ұйымдар жоқ.',

    serviceProviders_create: 'Қызмет көрсетушіні құру',
    serviceProviders_close: 'Ұйымды жабу',
    serviceProviders_reopened: 'Ұйымды қайта ашу',

    serviceProviders_errorLoadTable:
      'Қызмет көрсетушілердің тізілімін жүктеу мүмкін емес',
    serviceProviders_errorChangeFilter: 'Сүзгіні өзгерту мүмкін болмады',
    serviceProviders_deleteSuccess: 'Қызмет көрсеушілерді жою сәтті ақталды',
    serviceProviders_errorVerifyAddress:'Мекенжай тіркемесін тексеру мүмкін болмады',
    serviceProviders_deleteError: 'Қызмет көрсетушілерді жою мүмкін емес',
    serviceRequest_addressValid:'Мекенжай тіркеуін тексеру сәтті өтті',
    serviceRequest_addressNotFound:'Қазіргі уақытта Сіздің уақытша/тұрақты тіркеуіңіз туралы ақпарат ЖТМДҚ АЖ-мен интеграция арқылы автоматты өңдеу үшін қолжетімсіз',
    serviceRequest_addressNotMatch:'Мемлекеттік қызмет көрсетілетін елді мекенде тұрақты немесе уақытша тіркеу жоқ. Өтініш беру мүмкін емес. Уақытша немесе тұрақты тіркеу алу үшін тіркеу органдарына жүгініңіз.',
    serviceProviders_heirCloseTitle:
      'Жабылатын қызмет көрсетушінің өтінімдерін мұралануы',
    serviceProviders_heir_choose_providers: 'Қызмет көрсетушіні таңдаңыз',
    serviceProviders_heirCloseSuccess:
      'Қызмет берушіден тарихының мұралануы сәтті жабылды',
    serviceProviders_heirCloseError:
      'Қызмет көрсетушіден тарихының мұралануын жабу мүмкін емес',
    serviceProviders_heirReopened_title: 'Мұралануды қайта ашу',
    serviceProviders_heirReopened:
      'Сіз ұйымды{{id}} БСН нөмірімен қайта ашқыңыз келеді ме?',
    serviceProviders_heirReopenedSuccess:
      'Қызмет көрсетушіден тарихының мұралануы сәтті қайта ашылды',
    serviceProviders_heirReopenedError:
      'Қызмет берушіден тарихының мұраларын ашу мүмкін емес',
    serviceProviders_fioChild: 'Баланың аты-жөні',
    serviceProviders_exitedErrorListChildren: 'Балалар тізімін жүктеу мүмкін болмады',
    serviceProviders_didGiveYourConsent: 'Сіз деректерді жинауға және өңдеуге келісім берген жоқсыз.',
  }
});
